export function useScrollbarVisibility(dialogClass: string = '.v-dialog') {
  const bodyClass = 'disable-scroll'
  const bodyAttribute = 'data-dialogs-open'
  const paddingClass = 'pr-[15px]'

  function getBody(): HTMLBodyElement {
    return document.querySelector('body')!
  }

  function getDialog(): HTMLElement {
    return document.querySelector(dialogClass)!
  }

  function getAttribute(body: HTMLBodyElement): number {
    const attribute = body.getAttribute(bodyAttribute)

    return attribute ? parseInt(attribute, 10) : 0
  }

  function getScrollbarWidth() {
    const outer = document.createElement('div')
    outer.style.visibility = 'hidden'
    outer.style.overflow = 'scroll' // forcing scrollbar to appear
    document.body.appendChild(outer)

    const inner = document.createElement('div')
    outer.appendChild(inner)

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
    outer!.parentNode!.removeChild(outer)

    return scrollbarWidth
  }

  function setAttribute(body: HTMLBodyElement, attribute: number): void {
    body.setAttribute(bodyAttribute, attribute.toString())
  }

  function removeAttribute(body: HTMLBodyElement): void {
    body.removeAttribute(bodyAttribute)
  }

  function onDialogOpened() {
    const body = getBody()
    const dialog = getDialog()
    const attribute = getAttribute(body)

    setAttribute(body, attribute + 1)

    if (!body.classList.contains(bodyClass)) {
      body.classList.add(bodyClass)
    }

    if (!body.classList.contains(paddingClass) && window.innerHeight < dialog.scrollHeight) {
      body.style.paddingLeft = `${getScrollbarWidth()}px`
    }
  }

  function onDialogClosed() {
    const body = getBody()
    const attribute = getAttribute(body)

    if (attribute <= 1) {
      body.classList.remove(bodyClass)
      body.style.paddingLeft = 'initial'
      removeAttribute(body)
    } else {
      setAttribute(body, attribute - 1)
    }
  }

  return { onDialogOpened, onDialogClosed }
}
